import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoconstanciaComboReducer(state= initialState.cursoconstanciaCombo, action){
	switch(action.type){
		case types.GET_CURSOCONSTANCIAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}